module.exports = window["core-js/modules/es.object.to-string.js"];